import {
  ERPSeedless,
  ERPRJL,
  ERPUnity,
  ERPOdoo
} from "src/utils/constants";
import { IRoute } from "src/pages/Router/routes";

import CreateNotificationPage from "./CreateNotificationPage";
import NotificationDetailsPage from "./NotificationDetailsPage";

const AdminCreateNotificationMenu: IRoute[] = [
  {
    exact: true,
    path: "/platform/notifications/create",
    pageComponent: CreateNotificationPage,
    title: "%NOTIFICATION% Details",
    menuType: "ADMIN_CREATE_NOTIFICATION",
    context: "CREATE_EDIT_NOTIFICATION",
    permissions: [ "create-notification" ],
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ],
    privateRoute: true
  }
];

const AdminEditNotificationMenu: IRoute[] = [
  {
    exact: true,
    path: "/platform/notifications/:notificationId/details",
    pageComponent: NotificationDetailsPage,
    title: "%NOTIFICATION% Details",
    menuType: "ADMIN_EDIT_NOTIFICATION",
    context: "CREATE_EDIT_NOTIFICATION",
    permissions: [ "amend-notification" ],
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ],
    privateRoute: true
  }
];

export default [ ...AdminCreateNotificationMenu, ...AdminEditNotificationMenu ];
